import React from 'react';
import { InView } from 'react-intersection-observer';

import { TextButton } from '@components/Button/variants';
import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import IconArrow from '@components/Images/IconArrow';
import { THREAD_INPUT_PLACEHOLDER } from '@components/pages/AI/DeepResearch/Form/constants';
import DeepResearchSuggested from '@components/pages/AI/DeepResearch/Suggested';
import { SUGGESTED_PROMPT_QUERY_PARAM } from '@components/pages/AI/DeepResearch/constants';
import useEventTracking from '@hooks/useEventTracking';
import { deep_research_path } from '@routes';
import { ClickTarget, TrackingLocation, click, impression } from '@tracking';

import ForYouSection from './Section';
import { FOR_YOU_SECTION_IDS } from './constants';
import useRegisterSection from './useRegisterSection';

const ForYouDeepResearch = () => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.DeepResearchForYou,
  });
  useRegisterSection(FOR_YOU_SECTION_IDS.DeepResearch);

  const handleSuggestedPromptClick = (prompt) => {
    const anchor = document.createElement('a');
    anchor.href = deep_research_path({ [SUGGESTED_PROMPT_QUERY_PARAM]: prompt });
    anchor.click();
  };

  const handleDeepResearchClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.AnchorLink, clickText: THREAD_INPUT_PLACEHOLDER }));
  };

  return (
    <Track>
      <ForYouSection id={FOR_YOU_SECTION_IDS.DeepResearch}>
        <InView
          onChange={(inView) => {
            inView &&
              trackEvent(impression({ impressionElement: FOR_YOU_SECTION_IDS.DeepResearch }));
          }}
          triggerOnce
        >
          <div className="flex flex-col gap-8">
            <header>
              <IconDeepResearchText className="block" width={335} aria-label="Deep Research logo" />
              <p className="mb-0 mt-8 font-suisse-neue text-body-lg font-normal md:text-subheadline-sm">
                I am trained on The Information’s extensive reporting. Try asking me to…
              </p>
            </header>
            <div className="*:-mx-16 *:w-auto *:px-16 *:sm:mx-0 *:sm:px-0">
              <DeepResearchSuggested
                disablePrompts={false}
                setSuggestedPrompt={(prompt) => handleSuggestedPromptClick(prompt)}
              />
            </div>
            <TextButton
              as="link"
              className="group mt-28"
              href={deep_research_path()}
              onClickCapture={handleDeepResearchClick}
            >
              {THREAD_INPUT_PLACEHOLDER}
              <IconArrow
                className="ml-8 rotate-180 text-primary-magenta transition-transform duration-200 group-hover:translate-x-4"
                width={16}
              />
            </TextButton>
          </div>
        </InView>
      </ForYouSection>
    </Track>
  );
};

export default ForYouDeepResearch;
